"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

var _leaderboardEmptyData = _interopRequireDefault(require("./leaderboardEmptyData"));

var _LeaderboardEmptyModal = _interopRequireDefault(require("./LeaderboardEmptyModal"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.18);\n  margin-bottom: 0.75rem;\n"])));

var StyledWarapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var StyledOverlay = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to bottom,\n    ", ",\n    ", "\n  );\n"])), function (p) {
  return (0, _polished.rgba)(p.theme.colorLeaderboardBackground, 0.8);
}, function (p) {
  return (0, _polished.rgba)(p.theme.colorLeaderboardBackground, 1);
});

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      app = _ref.app,
      betbar = _ref.betbar,
      isInPlay = _ref.isInPlay,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages;

  var assetsCdn = function assetsCdn(index) {
    return "".concat(process.env.REACT_APP_IMAGE_CDN, "leaderboard/user").concat(index + 1, ".png");
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWarapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardEmptyModal.default, {
      language: app === null || app === void 0 ? void 0 : app.language,
      translations: translations,
      betbar: betbar,
      isUsingAlternativeImages: isUsingAlternativeImages
    }), _leaderboardEmptyData.default.map(function (_ref2, index) {
      var id = _ref2.id,
          username = _ref2.username,
          rank = _ref2.rank,
          points = _ref2.points,
          prize = _ref2.prize;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRow, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.LeaderboardRowHeader, {
          row: {
            prize: prize,
            rank: rank,
            points: points,
            user: {
              image: assetsCdn(index + 1),
              username: username
            }
          }
        })
      });
    })]
  });
};

var _default = Wrapper;
exports.default = _default;